(ns client-portal.client.products.data
  (:require [clojure.string :as s]
            [shared.core.reactive :as re]
            [shared.core.router :as router]
            [shared.core.util :as util]))

(def root-path [:products])
(def list-data-path (conj root-path :list :data))
(def selected-path (conj root-path :selected))

(defn list-data
  "The tenant's products ({:label :reference-id}, label order), or nil while loading.
   `:reference-id` is what identifies a product to the server."
  [db]
  (util/when-not-loading (get-in db list-data-path)))

(defn reference-ids [products]
  (into #{} (keep :reference-id) products))

(re/reg-auth0-loader
  :products/load-list-data
  list-data-path
  (fn [_ _]
    {:method :get
     :url "/api/products"})
  :transf (fn [resp] (or (some->> resp
                                  :body
                                  (util/->kebab-case-keywords)
                                  (mapv #(select-keys % [:label :reference-id]))
                                  (sort-by :label)
                                  (vec))
                         []))
  :error-transf (fn [] []))

(re/reg-auth0-load-sub
  :products/list-
  list-data-path
  :products/load-list-data)

(re/reg-sub
  :products/reference-ids-
  :<- [:products/list-]
  (fn [products]
    (reference-ids (util/when-not-loading products))))

(re/reg-event-db
  :products/select re/middleware
  (fn [db [product]]
    (assoc-in db selected-path product)))

(defn selected-product [db]
  (get-in db selected-path))

(re/reg-sub :products/selected- selected-product)

(defn selected-product-by-route [db]
  (let [cur-route (router/current-route-name db)
        route-starts-with? #(or (= (some-> cur-route (name)) %)
                                (some-> cur-route (name) (s/starts-with? (str % "-")))
                                (some-> cur-route (namespace) (s/starts-with? %)))]
    (cond
      (route-starts-with? "vi")
      "voice-insights"

      (route-starts-with? "vc")
      "voice-commerce"

      (route-starts-with? "so")
      "smart-ordering"

      :else
      nil)))
